import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  avatarUrl = new BehaviorSubject('');
  setAvatar(avatarUrl: string) {
    this.avatarUrl.next(avatarUrl);
  }

  httpHeaders = new HttpHeaders({'Content-type': 'application/json'});
  companiesUrl: string;
  clientsUrl: string;

  constructor(private http: HttpClient) {
    this.companiesUrl = environment.getBackendUrl('companies');
    this.clientsUrl = environment.getBackendUrl('clients');

  }

  getProfile(): Observable<any> {
    const body = {
      user_uuid: JSON.parse(localStorage.getItem('currentUser'))['user_uuid'],
    }
    return this.http.get(this.companiesUrl + '/user_info/',
    {
      params: body,
      headers: this.httpHeaders
    });
  }

  setCurrentCompany(id): Observable<any> {
    let body = {
      'company_id': id
    }
    return this.http.post(this.clientsUrl + '/actions/change_company/', body,
    {
      headers: this.httpHeaders
    });
  }

  getLastLogin(): Observable<any> {
    return this.http.get(this.companiesUrl + '/users/last_login/',
    {
      headers: this.httpHeaders
    });
  }
}
